import React from "react";

import "./index.scss";

const BlockDivider: React.FC = () => <div className="settings-block-divider" />;

export { BlockDivider };
